import Typography from '@mui/material/Typography';
import React from 'react';

import ExclamationSign from '@/assets/icons/exclamation-sign.svg?react';
import ArrowIcon from '@/assets/icons/right-arrow.svg?react';
import { Alert } from '@/components/molecules/Alert';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly count: number;
  onClick(): void;
}

export const AwaitingFundingBanner: React.FC<Props> = ({
  count,
  onClick,
}: Props): React.ReactElement => {
  const tr = useTranslator();

  const message =
    count === 1
      ? tr('AWAITING_FUNDING_BANNER_SINGULAR')
      : tr('AWAITING_FUNDING_BANNER_PLURAL', count);

  return (
    <Alert
      variant="warning"
      leftIcon={<ExclamationSign fill="currentColor" />}
      rightIcon={<ArrowIcon />}
      onClick={onClick}>
      <Typography variant="body2" color="text.primary">
        {message}
      </Typography>
    </Alert>
  );
};
